import { render } from "./AboutAll.vue?vue&type=template&id=a32d3f50&scoped=true"
import script from "./AboutAll.vue?vue&type=script&lang=js"
export * from "./AboutAll.vue?vue&type=script&lang=js"

import "./AboutAll.vue?vue&type=style&index=0&id=a32d3f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32d3f50"]])

export default __exports__